import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform, Type } from "class-transformer";
import { CollectiveAgreementDto } from "@/core/features/collective-agreements/collective-agreement.dto";
import { toEuros } from "@/utils/numberUtils";

export class CollectiveAgreementCategoryDto extends BaseEntityDto {
  @Type(() => CollectiveAgreementDto)
  collectiveAgreement?: CollectiveAgreementDto;

  collectiveAgreementId: string;

  name: string;

  @Transform(({ value }) => toEuros(value))
  hourlyRate: number;

  @Transform(({ value }) => toEuros(value))
  extraHourlyRate: number;

  @Transform(({ value }) => (value || value === 0 ? toEuros(value) : null))
  holidayHourlyRate?: number | null;

  toString(): string {
    return this.name;
  }
}
